/** Pull an already-saved edit from Yjs. Never apply replacement prose locally. */
export function syncAppliedAgentEdit({ provider, isComplete, isActive, onTimeout }) {
  const pending = () => isActive() && !isComplete();
  const lastMessageBefore = provider?.lastMessageReceived || 0;
  let probeSent = false;
  const unresponsive = () => probeSent && lastMessageBefore > 0
    && provider?.status === "connected"
    && provider.lastMessageReceived === lastMessageBefore;
  const requestSync = () => {
    try {
      if (provider?.status === "connected") {
        provider.forceSync();
        probeSent = true;
      }
      else provider?.connect();
    } catch (_) {
      // A failed request is not evidence that a healthy connection must be dropped.
    }
  };
  if (pending()) requestSync();
  const retry = setTimeout(() => {
    // A snippet mismatch can be a highlighting problem. Only drop a connection
    // that has received no messages since our explicit sync request.
    if (!pending() || !unresponsive()) return;
    try {
      provider?.disconnect();
      provider?.connect();
    } catch (_) {
      // Report the missing edit below even if reconnect itself fails.
    }
  }, 5000);
  const timeout = setTimeout(() => {
    if (pending()) {
      const responsive = provider?.status === "connected"
        && provider.lastMessageReceived > lastMessageBefore;
      onTimeout(responsive ? "highlight_not_found" : "sync_unconfirmed");
    }
  }, 10000);
  return () => {
    clearTimeout(retry);
    clearTimeout(timeout);
  };
}
